import { render, staticRenderFns } from "./CategoryGrid.vue?vue&type=template&id=256def06&scoped=true&"
import script from "./CategoryGrid.vue?vue&type=script&lang=js&"
export * from "./CategoryGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256def06",
  null
  
)

export default component.exports